import React from 'react';
import { styled } from 'styled-components';
import SvgCheck from '../../../../play-core/icons/Check';
import { Colors } from '../../../../play-core/styles/Colors';
import { HighlightText } from '../HighlightText/HighlightText';
import { IconWrapper } from '../IconWrapper/IconWrapper';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const MobileSelectionItem = ({
  item,
  onToggle,
  isSelected,
  searchTerm = ''
}) => /*#__PURE__*/_jsx(Container, {
  children: /*#__PURE__*/_jsx(ToggleButton, {
    onClick: () => onToggle(),
    children: /*#__PURE__*/_jsxs(Layout, {
      children: [isSelected ? /*#__PURE__*/_jsx(IconWrapper, {
        icon: /*#__PURE__*/_jsx(SvgCheck, {}),
        color: Colors.GREY_d2d2d2
      }) : /*#__PURE__*/_jsx(IconPlaceholder, {}), /*#__PURE__*/_jsxs(Text, {
        children: [/*#__PURE__*/_jsx(HighlightText, {
          text: item.title,
          highlight: searchTerm
        }), ' ', (item.count || item.count === 0) && /*#__PURE__*/_jsxs("span", {
          "aria-hidden": 'true',
          children: ["(", item.count, ")"]
        })]
      })]
    })
  })
});
const Container = styled.li.withConfig({
  displayName: "MobileSelectionItem__Container",
  componentId: "sc-1aqqzmm-0"
})(["display:flex;"]);
const ToggleButton = styled.button.withConfig({
  displayName: "MobileSelectionItem__ToggleButton",
  componentId: "sc-1aqqzmm-1"
})(["width:100%;text-transform:none;"]);
const Layout = styled.div.withConfig({
  displayName: "MobileSelectionItem__Layout",
  componentId: "sc-1aqqzmm-2"
})(["display:flex;align-items:center;color:", ";padding-left:24px;min-height:56px;"], Colors.GREY_d2d2d2);
const Text = styled.span.withConfig({
  displayName: "MobileSelectionItem__Text",
  componentId: "sc-1aqqzmm-3"
})(["padding-left:24px;text-align:start;"]);
const IconPlaceholder = styled.div.withConfig({
  displayName: "MobileSelectionItem__IconPlaceholder",
  componentId: "sc-1aqqzmm-4"
})(["min-width:24px;"]);